"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slaTiersList = exports.isFetchingSLATierList = void 0;
var slaTiersList = exports.slaTiersList = function slaTiersList(state) {
  return state.slaTiers.list;
};
var isFetchingSLATierList = exports.isFetchingSLATierList = function isFetchingSLATierList(state) {
  return state.slaTiers.ui.isFetchingList;
};
//# sourceMappingURL=selectors.js.map